<template>
    <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
    <div class="btn-type1" style="float:">
        <button class="btn-size btn-gray btn-space" @click="goSelect()">
        <span class="btn-icon">
            <i class="fas fa-save"></i>
        </span>
        선택
        </button>
        <button class="btn-size btn-gray" @click="goSearch()">
        <span class="btn-icon">
            <i class="fas fa-search"></i>
        </span>
        검색
        </button>
    </div>
    
    <div class="pop-content-search">
        
        <el-form size="mini" label-width="80px" label-position="right">
            <el-row>
                <el-col :span="18">
                    <el-form-item label="접수지역">
                        <el-input v-model="form.addr" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="기사명">
                        <el-select v-model="form.repairId" @change="goSearch">
                            <el-option
                                v-for="item in repairIds"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="지역">
                        <el-input v-model="form.areaAgentNm" readonly v-if="$store.state.loginInfo.groupUId =='29'"></el-input>
                        <el-select v-model="form.areaAgent" @change="getCombo1" v-else-if="!isAgentOrEngineer">
                            <el-option
                                v-for="item in areaAgents"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.areaAgentNm" readonly v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="센터명">
                        <el-input v-model="form.asAgentNm" readonly v-if="$store.state.loginInfo.groupUId =='29'"></el-input>
                        <el-select v-model="form.asAgentId" @change="getCombo2" v-else-if="!isAgentOrEngineer">
                            <el-option
                                v-for="item in asAgentIds"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="form.asAgentNm" readonly v-else></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-row v-if="!isAgentOrEngineer && $store.state.loginInfo.groupUId !='29'">
                        <el-col :span="8">
                            <el-form-item label="대체센터선택" label-width="100px" style="padding-right: 0px;">
                                <el-checkbox size="small" @change="(val) => this.form.subAsAgentYn = val ? 'Y' : 'N'" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="form.subAsAgentYn==='Y'">
                            <el-form-item label="대체지역">
                                <div style="color: #0065b3; font-weight: bold;">
                                    {{ subAsAgentIds.filter(x => x.catId === form.asAgentId)[0]?.subAreaNm }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="form.subAsAgentYn==='Y'">
                            <el-form-item label="대체센터">
                                <div style="color: #0065b3; font-weight: bold;">
                                    {{ subAsAgentIds.filter(x => x.catId === form.asAgentId)[0]?.subAsAgentNm }}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-form>
    </div>

        <div class="grid-wrap">
            <div class="table-area">
                <div class="table-b">
                    <ag-grid-vue 
                    style="width: 100%; height: 330px;"
                    class="ag-theme-alpine"    
                    :enableRangeSelection="true"
                    :framework-components="frameworkComponents"
                    :column-defs="columnDefs"     
                    :grid-options="gridOptions"
                    :row-data="rowData"
                    :default-col-def="defaultColDef"
                    @cell-clicked="onCellClicked"

                    @grid-ready="onGridReady"/>
                </div>
            </div>
        </div>
    </div>
  </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';

/**
 * * AG-Grid components
 */
import {AgGridVue} from 'ag-grid-vue';
import MaskEditCellRenderer from '@/components/agGrid/maskedit-cell-renderer'    
import { VModel } from 'vue-property-decorator';
import { emit } from 'process';


function _url(...args) {
  args = args.map(x => String(x || '').trim().replace(/^\/*|\/*$/g, ''))
  args = args.filter(x => x)
  return args.join('/')
}

export default {
    components: {AgGridVue},
    props: {
        data: {
            Type: Object
            , required: false
        },
    },
    components: {Layout},
    data() {
        return {
            title: '배정기사선택',
            form: {
                addr: '',
                areaAgent: '', /** 지역 */
                asAgentId: '', /** 센터명 */
                repairId: '',   /** 기사명 */
                modelGroupNm: '', /** 제품군 */
                subModelGroup: '', /** 하위 제품군 */
                subAsAgentYn: 'N', /** 대체센터 여부 */
                subAreaAgent: '', /** 대체지역 */
                subAsAgentId: '', /** 대체센터 */
                subAsAgentNm: '',/** 대체센터 명*/
            },
            isAgentOrEngineer: true, // AS기사(5), 센터관리자(6) 여부
            areaAgents: [],
            areaAgentsKey: [], /** 지역 CAT_KEY*/
            asAgentIds: [],  /** 센터명 리스트 */
            subAsAgentIds: [],  /** 대체 센터명 리스트 */
            repairIds: [],  /** 기사명 리스트 */
            prevIdx: -1,    /** 이전 클릭 인덱스 */
            prevField: '',  /** 이전 클릭 필드명 */
            modelGroupList: [],   /** 제품군 리스트*/
            modelGroupNmList: [],   /** 제품군 리스트*/
            subModelGroupList: [],  /** 하위 제품군 리스트*/
            subModelGroupIdList: [],  /** 하위 제품군 리스트*/

            // AG-GRID OPTION [START]
            rowData:[],
            rowDataOrg:[], /** 조회후 데이타 백업 */
            gridOptions: {},
            frameworkComponents : {
                maskEdit: MaskEditCellRenderer,
            },
            columnDefs:[
                {
                    headerName:'기사명', 
                    field:'userNm', 
                    width:140,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'센터명', 
                    field:'asAgentNm', 
                    width:150,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName:'담당지역', 
                    field:'area', 
                    width:230,
                    cellStyle : {textAlign: 'center'}
                },
                {
                    headerName: '핸드폰', 
                    field:'hpNo', 
                    width: 140,
                    cellStyle:{textAlign:'left'},
                    cellRenderer: 'mask',
                    cellRendererParams: {
                        mask: "XXX-XXXX-XXXX" 
                    }  
                },
                {
                    headerName: '당일', 
                    field:'today', 
                    children: [{
                        headerName: '오전',
                        field: 'morn',
                        headerClass: 'hide-cell',
                        width: 90,
                        cellStyle: (params) => {
                            const idx = params.rowIndex;
                            const field = params.colDef.field;
                            if(field === this.prevField && idx === this.prevIdx){
                                return {backgroundColor: '#D5E6A3'};
                            } else {
                                return null;
                            }
                        }
                    },{
                        headerName: '오후',
                        field: 'after',
                        headerClass: 'hide-cell',
                        width: 90,
                        cellStyle: (params) => {
                            const idx = params.rowIndex;
                            const field = params.colDef.field;
                            if(field === this.prevField && idx === this.prevIdx){
                                return {backgroundColor: '#D5E6A3'};
                            } else {
                                return null;
                            }
                        }
                    }],
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '익일',
                    headerClass: 'header-rowspan-2',
                    children: [{
                        headerName: '오전',
                        field: 'toMorn',
                        headerClass: 'hide-cell',
                        width: 90,
                        cellStyle: (params) => {
                            const idx = params.rowIndex;
                            const field = params.colDef.field;
                            if(field === this.prevField && idx === this.prevIdx){
                                return {backgroundColor: '#D5E6A3'};
                            } else {
                                return null;
                            }
                        }
                    },{
                        headerName: '오후',
                        field: 'toAfter',
                        headerClass: 'hide-cell',
                        width: 90,
                        cellStyle: (params) => {
                            const idx = params.rowIndex;
                            const field = params.colDef.field;
                            if(field === this.prevField && idx === this.prevIdx){
                                return {backgroundColor: '#D5E6A3'};
                            } else {
                                return null;
                            }
                        }
                    }],
                    cellStyle:{textAlign:'left'}
                },
                {
                    headerName: '익익일',
                    headerClass: 'header-rowspan-2',
                    children: [{
                        headerName: '오전',
                        field: 'dotMorn',
                        headerClass: 'hide-cell',
                        width: 90,
                        cellStyle: (params) => {
                            const idx = params.rowIndex;
                            const field = params.colDef.field;
                            if(field === this.prevField && idx === this.prevIdx){
                                return {backgroundColor: '#D5E6A3'};
                            } else {
                                return null;
                            }
                        }
                    },{
                        headerName: '오후',
                        field: 'dotAfter',
                        headerClass: 'hide-cell',
                        width: 90,
                        cellStyle: (params) => {
                            const idx = params.rowIndex;
                            const field = params.colDef.field;
                            if(field === this.prevField && idx === this.prevIdx){
                                return {backgroundColor: '#D5E6A3'};
                            } else {
                                return null;
                            }
                        }
                    }],
                    cellStyle:{textAlign:'left'}
                },
            ],
            defaultColDef: { 
                resizable: true, 
                filter:true, 
                sortable: true 
            },
            // AG-GRID OPTION [END]
        }
    },
    mounted() {
        console.log('mounted data : ', this.data);
        let vform = {
            ...this.form,
            ...this.data
        };

        if(this.$store.state.loginInfo.groupUId===5 || this.$store.state.loginInfo.groupUId===6){
            this.isAgentOrEngineer = true; // AS기사(5), 센터관리자(6) 여부
            this.form.asAgentId = this.$store.state.loginInfo.asAgentId;
            vform.asAgentId = this.$store.state.loginInfo.asAgentId;
        } else {
            this.isAgentOrEngineer = false;
        }
        
        
        console.log('mounted vform : ', vform);
        this.form = JSON.parse(JSON.stringify(vform));
        this.form.addr = this.form.addr1 + ' ' + this.form.addr2;
        this.getCombo({callBy:'INIT'});
        
        //pop slots modal move
        $(".animation-content").addClass('pop_min2');
        $(".animation-content").draggable({'cancel':'.modal-card-body'});
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '4');
    },
    destroyed() {
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '7');
    },
    methods: {
        changeTab(params) {
            this.viewer = params.tabId;
        },
        closeModal() {
            console.log(this.$parent)
            this.$parent.close();
        },
        handleNodeClick(data) {
            console.log(data);
        },
        onGridReady(){
        
        },
        onCellClicked(params) {
            const idx = params.rowIndex;
            const field = params.colDef.field;
            if(field === 'morn' || field === 'toMorn' || field === 'dotMorn' ||
                field === 'after' || field === 'toAfter' || field === 'dotAfter'
            ) {
                
                if(this.prevIdx === idx && this.prevField === field) {
                    // 이미 클릭시 exit
                    return false;
                }
                
                this.prevIdx = idx;
                this.prevField = field;

                const vModelCnt = this.data.modelCnt || '1';
                const arrVal = params.data ? params.data[field].split('/') : [];
                console.log('cell click : ',  params, params.data[field], arrVal);

                let chgVal = '0/0';
                if(arrVal.length >= 2){
                    const tmpVal = parseInt(arrVal[1]) + Number(vModelCnt);
                    chgVal = (arrVal[0] + '/' + tmpVal.toString());
                    
                }

                const chgObj = JSON.parse(JSON.stringify(this.rowDataOrg));
                this.rowData = chgObj.map((x,index)=>{
                    if(index === idx){
                        x[field] = chgVal;
                    }

                    return x;
                })

            }
            // this.$emit('close', params.data);
        },
        getCombo1(param) {
            /** 지역 콤보 변경시 */
            console.log('getCombo1 start')
            this.getCombo({callBy : 'AREA', child1: param})
        },
        getCombo2(param) {
            /** 센터명 콤보 변경시 */
            console.log('getCombo2 start');
            this.getCombo({callBy : 'CENTER', child1: param});

            // this.form.subAsAgentId = '';
            // if(this.form.subAsAgentYn === 'Y'){
            //     const vObj = this.asAgentIds.filter(x=>x.catId == param);
            //     if(vObj && vObj.length > 0){
            //         this.form.subAsAgentId = vObj[0].subAsAgentId || '';
            //     }
            // }
            
        },

        getCombo(param) {
            /** 
             * 사이트명 조회시 센터코드(CAT_KEY)값만 파라미터로 받을 수 있어서 
             * 초기로딩시에는 child1 = CAT_KEY 로 셋팅하여 콤보데이타를 가져오고
             * 이후로는 각 콤보의 하위콤보에 대해서 PARENT_ID로 동작으로 구성함.
             */
            //console.log('getCombo start===', param)
            const vm = this;
            let vChild1 = '';
            let vChild1Col = ''; // child1의 값이 cat_key 인경우 C

            if(param.callBy === 'INIT'){
                // 초기로딩시
                vChild1 = this.form.asAgentId;
                vChild1Col = 'C'; // 초기로딩시 child1의 값이 cat_key
                //console.log('getCombo Init pass vChild1 : ', vChild1)

                 

            } else {
                 
                // 지역 혹은 센터명 변경시
                if(param.callBy === 'AREA'){
                    vChild1 = param.child1;
                    console.log('area change pass 01', param.child1);
                    if(param.child1 === 0){
                        vm.form.asAgentId = '';
                        vm.asAgentIds = [];
                        vm.form.repairId = '';
                        vm.repairIds = [];
                        vm.form.subModelGroup = '';    
                        console.log('area change pass 02');
                        return false
                    }
                    
                } else if(param.callBy === 'CENTER'){
                    if(param.child1 === 0){
                        vm.form.repairId = ''
                        vm.repairIds = []    

                        return false
                    }
                    
                    // CAT_ID => CAT_KEY 변환
                    let filterCatKey = '';
                    if(this.form.subAsAgentYn === 'Y' && this.subAsAgentIds.filter(x => x.catId === param.child1)) {
                        filterCatKey = this.subAsAgentIds.filter(x => x.catId === param.child1)[0]?.subAsAgentId
                    } else {
                        filterCatKey = vm.asAgentIds.filter(x=>x.catId === param.child1)[0]?.catKey
                    }

                    //console.log('filterCatKey ---: ', filterCatKey)
                    vChild1 = filterCatKey || ''    // 센터명
                
                }
            }

            const vform = {
                companyId: this.$store.state.loginInfo.compCd, 
                parentId: '217',
                child1: vChild1,
                child1Col: vChild1Col,
                child2: '',
                child3: '',
                searchFlag: (this.form.asAgentId && this.form.asAgentId != '') ? "AS_USER" : ''
            }

            if(this.$store.state.loginInfo.groupUId =='29'){
                vform.searchFlag = 'AS_USER';
                vform.child1 = '193';
                
            }

            this.$http.get(`/api/asMng/call/combo`, {params: vform})
                .then(response => {
                    const respCombo = response.data.getComboList;
                    const respAsuser = response.data.getAsUserList || [];

                    console.log('respCombo : ', _.cloneDeep(respCombo));

                    if(param.callBy === 'INIT'){
                        /** ===============초기로딩시===================================== */
                        
                        // 지역 리스트
                        vm.areaAgents = respCombo.filter(x=>x.pcFlag==='P')
                            .map(y=>{
                                y.key = y.catId
                                y.value = y.catId
                                y.label = y.catNm
                                return y
                            }) || [];
                        vm.areaAgents.unshift({
                            ...vm.areaAgents[0], 
                            catId: 0, catIdx: 0, catNm:'선택', key:0, parentId: 0, value:0, label:'선택' });
                        
                        // 센터명 리스트
                        vm.asAgentIds = [];
                        vm.asAgentIds = respCombo.filter(x=>x.pcFlag==='C1')
                        .filter(z=>z.contractStatus != 'N')    
                        .map(y=>{
                                y.key = y.catId
                                y.value = y.catId
                                y.label = '[' + y.catKey + ']' + y.catNm
                                return y
                            }) || [];
                        vm.asAgentIds.unshift({
                            ...vm.asAgentIds[0], 
                            catId: 0, catIdx: 0, catKey:'', catNm:'선택', key:0, parentId: 0, value:0, label:'선택' });

                        vm.form.areaAgent = vm.asAgentIds[1] ? vm.asAgentIds[1].parentId : ''; // 지역 설정

                        if(this.$store.state.loginInfo.groupUId =='29'){
                            vm.form.areaAgent = '237'; // 대행사의 경우 : 공통 
                        }

                        const vSelAreaObj = vm.areaAgents.filter(x=>x.key==vm.form.areaAgent);
                        if(vSelAreaObj && vSelAreaObj.length>0){
                            vm.form.areaAgentNm = vSelAreaObj[0].catNm;
                        }
                         
                        //초기의 CAT_KEY에 해당하는 CAT_ID를 조회
                        // CAT_KEY => CAT_ID 변환
                        let filterCatIdObj = vm.asAgentIds.filter(x=>x.catKey == vm.form.asAgentId)
                            .map(x=>{
                                return {catId : x.catId, catNm: x.catNm};
                            });

                        if(vm.$store.state.loginInfo.groupUId =='29'){
                            filterCatIdObj = [{catId : '27544', catNm: '용인본사'}];
                        }
                        

                        if(filterCatIdObj && filterCatIdObj.length>0) {
                            vm.form.asAgentId = filterCatIdObj[0].catId || '';    // 센터명
                            vm.form.asAgentNm = filterCatIdObj[0].catNm || '';    // 센터명
                        } else {
                            vm.form.asAgentId = '';    // 센터명
                            vm.form.asAgentNm = '';    // 센터명
                        }
                        
                                          
                        if( vm.form.asAgentId.length  === 0 ){
                            vm.rowData = []
                            vm.rowDataOrg = []
                            vm.repairIds = []
                            vm.repairId = ''
                            
                            return false
                        }

                        // 기사명 vm.repairIds    
                        vm.repairIds = respAsuser.map(x=>{
                            x.key = x.userId
                            x.value = x.userId
                            x.label = x.userNm
                            //x.value = '[' + x.userCd + ']' + x.userNm
                            return x
                        })
                        
                        vm.repairIds.unshift({
                            ...vm.repairIds[0], 
                            key:'0', value:'0', label:'전체', userCd: '', userId: '', userNm: '', asAgentId: '0' })

                        vm.goSearch('Y')    

                        /** ===============초기로딩시=END==================================== */

                    } else if(param.callBy == 'AREA'){
                        /** ===============지역 변경시==================================== */
                        // 센터명 리스트
                        vm.asAgentIds = []
                        vm.form.asAgentId = ''
                        vm.repairIds = []  
                        vm.form.repairId = ''
                        
                        vm.asAgentIds = respCombo.filter(x=>x.pcFlag==='C1')
                            .filter(z=>z.contractStatus != 'N')
                            .map(y=>{
                                y.key = y.catId
                                y.value = y.catId
                                y.label = '[' + y.catKey + ']' + y.catNm

                                return y
                            }) || []
                        vm.asAgentIds.unshift({
                            ...vm.asAgentIds[0], 
                            catId: 0, catIdx: 0, catKey:'', catNm:'선택', key:0, parentId: 0, value:0, label:'선택' });
                        //대체 센터 기본 세팅
                        this.subAsAgentIds = vm.asAgentIds.filter(x => x.subAreaCd);
                    } else if(param.callBy == 'CENTER'){
                        /** ===============센터명 변경시==================================== */
                        
                        // 기사명 vm.repairIds    
                        let vRepairIdsObj =  respAsuser.map(x=>{
                            const vRepairId = {
                                key : x.userId,
                                value : x.userId,
                                label : x.userNm
                            }
                            return vRepairId
                        })
                        vRepairIdsObj.unshift({ key:'0', value:'0', label:'전체'})
                        // 기사명 vm.repairIds    
                        vm.repairIds = JSON.parse(JSON.stringify(vRepairIdsObj))

                        vm.form.repairId = ''
                        
                    }
                }); 
                
        },      
        goSearch(vInitYn){
            let vAsAgentId = ''
            console.log('goSearch this.form.subModelGroup : ', this.form.subModelGroup)
            console.log('goSearch this.form.asAgentId : ', this.form.asAgentId)
            // 센터명과 제품군이 선택안된 경우 Exit
            if(this.form.modelGroupNm==='' && (this.form.asAgentId.length  === 0  || this.form.asAgentId == '0')){
                this.rowData = [];
                this.rowDataOrg = [];
                this.repairIds = [];
                this.repairId = '';

                if(this.form.areaAgent==='' || this.form.areaAgent=='0'){
                    this.$swal({ type: 'warning', text: '지역을 선택해 주세요.' })
                    return false;
                }

                if(this.form.subAsAgentYn==='N' && (this.form.asAgentId == '0' || this.form.asAgentId == '') ){
                    this.$swal({ type: 'warning', text: '센터명을 선택해 주세요.' })
                    return false;
                }

                if(this.form.subAsAgentYn==='Y' && (this.form.subAsAgentId == '') ){
                    this.$swal({ type: 'warning', text: '대체센터가 없습니다. 기초관리 > 센터관리에서 대체센터를 지정후 사용가능합니다.' })
                    return false;
                }
                console.log('=====exit1 ')
                return false;
            }

            if (this.form.asAgentId){
                // CAT_ID => CAT_KEY 변환
                const filterCatKey = this.asAgentIds.filter(x=>x.catId === this.form.asAgentId)
                        .map(x=>{
                            return x.catKey
                        })

                console.log('filterCatKey ---: ', filterCatKey)
                vAsAgentId = filterCatKey[0] ? filterCatKey[0] : '0';    // 센터명
                if(this.form.subAsAgentYn === 'Y') {
                    vAsAgentId = this.subAsAgentIds.filter(x => x.catId === this.form.asAgentId)[0]?.subAsAgentId
                    if(!vAsAgentId) {
                        this.$message.error(`선택 가능한 대체센터 기사 정보가 존재하지 않습니다.`);
                        return false;
                    }
                }
            } else {
                vAsAgentId = this.form.asAgentId || '0';
            }

            if(this.$store.state.loginInfo.groupUId =='29'){
                vAsAgentId = '193';
            }
            
            const vform = {
                companyId: this.$store.state.loginInfo.compCd || '',
                initYn: vInitYn,
                //asAgentId: '103',
                asAgentId: vAsAgentId,
                userId: this.form.repairId  || 0 ,
                useYn: 'Y',
                catId: 0,
                sortType: '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }


            console.log('vform select aaa : ', vform);

            this.$store.commit('loading') ;
            this.$http.post(_url("/api/asMng/popup/repairScheduleSelect"), vform
                ).then(response => {
                    console.log('RepairScheduleSelect response.data' , response.data);
                    this.rowData = response.data.callServiceEngineerFindAgentList;
                    this.rowData.map(x=>{
                        x.morn = (x.type_01 === '') ? x.qty_01 + '/' + x.allocQty_01 : '';
                        x.after = (x.type_02 === '') ? x.qty_02 + '/' + x.allocQty_02 : '';
                        x.toMorn = (x.type_11 === '') ? x.qty_11 + '/' + x.allocQty_11 : '';
                        x.toAfter = (x.type_12 === '') ? x.qty_12 + '/' + x.allocQty_11 : '';
                        x.dotMorn = (x.type_21 === '') ? x.qty_21 + '/' + x.allocQty_21 : '';
                        x.dotAfter = (x.type_22 === '') ? x.qty_22 + '/' + x.allocQty_22 : '';
                        
                        return x;
                    })

                    this.rowDataOrg = this.rowData;
            }).finally(() => {
                this.$store.commit('finish');
          });

        },
        goSelect(params){
            /** 선택버튼 */
            console.log('goSelect:', params)

            let vobj = {
                areaAgent: this.form.areaAgent,
                ...this.rowData[this.prevIdx],
                selField: this.prevField
            }

            if(this.prevIdx === -1){
                // 배정기사가 선택안한 경우 초기화
                vobj.areaAgent = ''
                vobj.asAgentId = ''
                vobj.asAgentNm = ''
                vobj.userId = ''
                vobj.userNm = ''
                vobj.selField = ''
            }

            this.$emit('close', vobj);
        }
    },
    watch: {
        'form.subAsAgentYn' (value) {
            console.log("value ", value)
            if(value === 'Y') {
                const center = this.subAsAgentIds.filter(x => x.catId === this.form.asAgentId);
                if(this.subAsAgentIds && this.subAsAgentIds.length > 0) {
                    this.getCombo({callBy : 'CENTER', child1: center[0]?.value});
                } else {
                    this.getCombo({callBy : 'AREA', child1: this.form.areaAgent});    
                }
            } else {
                this.getCombo({callBy : 'CENTER', child1: this.form.asAgentId});
            }
        }
    }

}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }

// .btn-space {
//  margin-right: 4px;
// }
</style>